import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorModule } from '@progress/kendo-angular-editor';
import { BaseFormControlComponent } from '../../../classes/base-form-control.component';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { EditorComponent as BizzEditorComponent } from '../../../../../../shared/components/editor/editor.component';

/**
 * Represents a control with a rich text editor.
 * Can be simple or contain formatting options and HTML.
 */
@Component({
  selector: 'bizz-memo-control',
  standalone: true,
  imports: [CommonModule, EditorModule, ButtonModule, BizzEditorComponent],
  templateUrl: './memo-control.component.html',
  styleUrls: ['./memo-control.component.scss']
})
export class MemoControlComponent extends BaseFormControlComponent implements AfterViewInit {

  @ViewChild('editor') public editor: BizzEditorComponent;

  public readonly MIN_EDITOR_HEIGHT = 125;
  //light editor didn't have a min height in legacy so it's about two lines now.
  public readonly MIN_LIGHT_EDITOR_HEIGHT = 64;

  public editorHeight = this.MIN_EDITOR_HEIGHT;

  public override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    const formField = this.formFieldSignal();
    if (formField) {
      if (formField.ShowHTMLEditor || !(this.readOnlyOverride || formField.IsReadOnly)) {
        this.editorHeight = Math.max(formField.Height, this.MIN_EDITOR_HEIGHT);
      } else {
        this.editorHeight = Math.max(formField.Height, this.MIN_LIGHT_EDITOR_HEIGHT);
      }
    }

    const objFrame = document.getElementById(this.formId + this.formFieldSignal()?.Bookmark);
    const iframeObj = objFrame ? objFrame.getElementsByTagName('iframe') : undefined;

    if (iframeObj && iframeObj.length > 0) {
      iframeObj[0].setAttribute('tabindex', (this.readOnlyOverride || this.formFieldSignal()?.IsReadOnly ? '-1' : '0'));
    }
  }

  public setValue(value: string): void {
    this.formControl.markAsDirty();
    this.formControl.setValue(value, { emitEvent: false });
  }

  public submitValue(): void {
    this.formControl.setValue(this.formControl.getRawValue());
  }

  // Implement the abstract member from MemoControlComponent
  protected override focus(): void {
    setTimeout(() => {
      this.editor.focus();
    }, 10);
  }
}